// extracted by mini-css-extract-plugin
module.exports = {"img1":"SigninNavBar_img1__3qs_n"};